"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Single portfolio configs model selected in configurations.
 */
var BasePortfolioConfigModel = /** @class */ (function () {
    function BasePortfolioConfigModel() {
        this.quickFilterField = null;
        this.defaultSortingField = null;
        this.sortingDirection = 'DESC';
        this.filterFields = [];
        this.fields = [];
    }
    return BasePortfolioConfigModel;
}());
exports.BasePortfolioConfigModel = BasePortfolioConfigModel;
//# sourceMappingURL=base-portfolio-config.model.js.map